import { render, staticRenderFns } from "./Hotels.vue?vue&type=template&id=20f35dfa&scoped=true"
import script from "./Hotels.vue?vue&type=script&lang=js"
export * from "./Hotels.vue?vue&type=script&lang=js"
import style0 from "./Hotels.vue?vue&type=style&index=0&id=20f35dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f35dfa",
  null
  
)

export default component.exports